<template>
  <div>
    <b-card>
      <div class="organism-idc-management_header card-padding">
        <span class="header__label">NTDC Database</span>
      </div>
      <div class="filter-container card-padding pt-0">
        <div class="row">
          <div class="col-12 col-lg-4">
            <atom-input
              v-model="filterList.idcId"
              :title="contractIdLabel"
              :placeholder="contractIdLabel"
              type="number"
              :maxLength="8"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-4 mt-1 mt-lg-0">
            <atom-input
              v-model="filterList.additionalId"
              title="Additional ID"
              placeholder="Additional ID"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-4 mt-1 mt-lg-0">
            <atom-select
              v-model="filterList.customer"
              label="customerName"
              title="Customer Name"
              placeholder="Customer Name"
              :isEnableProper="false"
              :isAppendToBody="false"
              :option="customerNameOption"
            ></atom-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-4 mt-1">
            <atom-multi-select
              title="Location"
              placeholder="All Location"
              v-model="filterList.location"
              label="label"
              :isEnableProper="false"
              :isAppendToBody="false"
              :option="locationOption"
            ></atom-multi-select>
          </div>
          <div class="col-12 col-lg-4 mt-1">
            <atom-input
              title="Domain Name"
              placeholder="Domain Name"
              v-model="filterList.domainName"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-4 mt-1">
            <atom-select
              title="Sale Contact"
              placeholder="Sale Contact"
              v-model="filterList.saleContact"
              label="contactPointName"
              :isEnableProper="false"
              :isAppendToBody="false"
              :option="saleContactOption"
            ></atom-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-4 mt-1">
            <atom-multi-select
              v-model="filterList.packageAndService"
              title="Package"
              placeholder="Package Name"
              label="name"
              :isEnableProper="false"
              :isAppendToBody="false"
              :option="serviceAndPackageNameOption"
            ></atom-multi-select>
          </div>
          <div class="col-12 col-lg-8 mt-1 d-flex justify-content-between">
            <atom-multi-select
              title="Status"
              placeholder="All Status"
              v-model="filterList.status"
              label="name"
              :isEnableProper="false"
              :isAppendToBody="false"
              :option="statusOption"
            ></atom-multi-select>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                class="search__button ml-2"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row card-padding-top card-padding-x">
        <div
          class="col-12 d-flex flex-column-reverse flex-md-row justify-content-between align-items-md-end"
        >
          <div class="contract-status-count mt-1 mt-md-0">
            <span class="text-uppercase text-medium-grey">
              Contract Status
            </span>
            <div class="d-flex badge-wrapper">
              <b-badge
                pill
                variant="light-primary"
                class="badge--width font-12px"
              >
                {{ contractAmount.all }} All
              </b-badge>
              <b-badge pill variant="light-info" class="badge--width font-12px">
                {{ contractAmount.pending }} Pending
              </b-badge>
              <b-badge
                pill
                variant="light-success"
                class="badge--width font-12px"
              >
                {{ contractAmount.approved }} Approved
              </b-badge>
              <b-badge
                pill
                variant="light-warning"
                class="badge--width font-12px"
              >
                {{ contractAmount.suspended }} Suspended
              </b-badge>
              <b-badge
                pill
                variant="light-secondary"
                class="badge--width font-12px"
              >
                {{ contractAmount.expired }} Expired
              </b-badge>
            </div>
          </div>
          <div
            v-if="hasUpdateNtdcContractPermission"
            class="d-flex justify-content-end custom-button-margin-top"
          >
            <atom-button
              buttonId="create-new-contract"
              class="header__button"
              buttonStyle="border"
              @click="goToCreateContract"
            >
              <template>New Service Contract</template>
            </atom-button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div
            class="card-padding organism-idc-management__scroll"
            :class="{ 'empty-rows': !items.length }"
          >
            <molecule-contract-item
              v-for="(item, index) in items"
              :key="index"
              :data="item"
              @click="selectRow"
            ></molecule-contract-item>
          </div>

          <div
            v-if="!items.length"
            class="d-flex flex-column align-items-center justify-content-center my-4"
          >
            <feather-icon
              icon="CloudOffIcon"
              class="empty-data__icon"
            ></feather-icon>
            <label class="empty-data__text--title">No Data</label>
          </div>
        </div>
      </div>
      <molecule-pagination-with-per-page
        :page="filterList.currentPage"
        :total-count="filterList.totalCount"
        :per-page="filterList.perPage"
        @onUpdatePaginationOrPerPage="onUpdatePaginationOrPerPage"
      ></molecule-pagination-with-per-page>
    </b-card>
    <footer style="height: 1px"></footer>
  </div>
</template>

<script>
import { BCard, BBadge, BPagination } from "bootstrap-vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeContractItem from "@/components/molecules/portal/idc/MoleculeContractItem.vue"
import MoleculePaginationWithPerPage from "@/components/molecules/MoleculePaginationWithPerPage.vue"
import mixins from "@/mixins"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismIdcManagement",
  components: {
    BCard,
    BPagination,
    BBadge,
    AtomInput,
    AtomSelect,
    AtomMultiSelect,
    AtomButton,
    MoleculeContractItem,
    MoleculePaginationWithPerPage,
  },
  mixins: [mixins, mixinsUser],
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    contractAmount: {
      required: true,
      type: Object,
    },
    customerNameOption: {
      required: true,
      type: Array,
    },
    locationOption: {
      required: true,
      type: Array,
    },
    statusOption: {
      required: true,
      type: Array,
    },
    saleContactOption: {
      required: true,
      type: Array,
    },
    serviceAndPackageNameOption: {
      required: true,
      type: Array,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    hasUpdateNtdcContractPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTRACT_WRITE)
    },
  },
  methods: {
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },
    selectRow(record) {
      this.$emit("clickRow", record)
    },
    goToCreateContract() {
      this.$router.push("/internal/web-portal/idc/contract/create")
    },

    onUpdatePaginationOrPerPage(currentPerPage, currentPage) {
      const updatedFilter = {
        ...this.filterList,
        currentPage,
        perPage: currentPerPage,
      }
      this.$emit("onUpdateCurrentPageOrPerPage", updatedFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-idc-management_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.filter-container {
  border-bottom: 1px solid #e9ecef;
}
.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}
.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #6e6b7b;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

.custom-padding-left {
  padding-left: 18px !important;
}

.text-grey-color {
  color: #b9b9c3;
}

.font-12px {
  font-size: 12px;
}

.font-9px {
  font-size: 9px;
}

.badge-wrapper {
  margin-top: 6px;
  gap: 16px;
  flex-wrap: wrap;
}

.header__button {
  width: 100%;
}

.organism-idc-management__scroll {
  overflow: auto;
  width: 100%;
  min-height: 600px;
  max-height: calc(100vh - 600px);
  &.empty-rows {
    min-height: 0px;
  }
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .header__button {
    width: fit-content;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}
</style>
